import { differenceInCalendarDays, parseISO } from 'date-fns';
import { useMemo } from 'react';
import { getPeriodName, weekDaysPeriod } from 'reactApp/utils/Period';

export function usePromoCountdown(endDate: string) {
    const daysLeft = useMemo(() => differenceInCalendarDays(parseISO(endDate), new Date()), [endDate]);

    return {
        daysLeft,
        isPromoActive: daysLeft >= 0,
        daysLeftText: getPeriodName(`${daysLeft}d`, true, false, true),
        periodLeftText: weekDaysPeriod(daysLeft),
    };
}
